import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { addItem, updateItem, deleteItem, updateOrder, updateFractalOrder } from './helpers'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.advertisements)

const advertisementsReducer = (state = INIT_STATE, action) => {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.ADVERTISEMENTS_ADD_ITEM:
            return addItem(state, action);
        case actionTypes.ADVERTISEMENTS_UPDATE_ITEM:
            return updateItem(state, action);
        case actionTypes.ADVERTISEMENTS_DELETE_ITEM:
            return deleteItem(state, action);
        case actionTypes.ADVERTISEMENTS_UPDATE_ORDER:
            return updateOrder(state, action)
        case actionTypes.ADVERTISEMENTS_UPDATE_ITEM_ORDER:
            return updateFractalOrder(state, action)
        default:
            return state;
    }
}

export default advertisementsReducer